module.exports = __webpack_public_path__ + "img/31.15c0cf15.png";